import Vue from 'vue';
import Router from 'vue-router';
import IndexInfo from '@/components/IndexInfo.vue';
import ServiceList from '@/components/ServiceList.vue';
import PayMent from '@/components/PayMent.vue';
import IntroduceAbout from '@/components/IntroduceAbout.vue';
import axios from "axios";

import { getWithExpiry } from '@/utils/globalFunctions'; // 直接导入函数
import { USER_TOKEN } from '@/utils/CommonConstant'; // 直接导入函数

// 注册 Router 插件
Vue.use(Router);

// export default new Router({
const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式
  routes: [
    {
      path: '/',
      name: 'IndexInfo',
      component: IndexInfo, // 首页
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index/ServiceList',
      name: 'ServiceList',
      component: ServiceList,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index/payment',
      name: 'PayMent',
      component: PayMent,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index/about',
      name: 'IntroduceAbout',
      component: IntroduceAbout,
      meta: {
        requireAuth: false
      }
    }
  ],
});


// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {
//     const isAuthenticated = getWithExpiry(USER_TOKEN);
//     if (isAuthenticated) {
//       // 如果有 token，先发请求检查是否已登录
//       axios.get("/crm/user/checkLoginStatus", {
//         headers: {
//           'token': isAuthenticated
//         }
//       }).then((response) => {
//         if (response.data.status === "1") {
//           // 用户已登录，允许访问
//           next();
//         } else {
//           // 登录状态无效，跳转到登录页
//           next({ path: '/user/login' });
//         }
//       }).catch(() => {
//         console.info("验证登录失败");
//         // 请求失败或验证失败，跳转到登录页
//         next({ path: '/user/login' });
//       });
//     } else {
//       console.info("token失效");
//       // 未登录，跳转到登录页
//       next({ path: '/user/login' });
//     }
//   } else {
//     // 不需要登录拦截
//     next();
//   }
// });

// todo 导航守卫：登录拦截  
router.beforeEach((to, from, next) => {
  // console.log("导航守卫：登录拦截", to, from, next);
  if (to.meta.requireAuth) {
    const isAuthenticated = getWithExpiry(USER_TOKEN)
    if (isAuthenticated) {
      // 如果有 token，先发请求检查是否已登录
      axios.get("/crm/user/checkLoginStatus", {
          headers: {
            'token': isAuthenticated
          }
        }).then((response) => {
          if (response.data.status === "1") {
            // 异步操作后再跳转
            setTimeout(() => {
              next();
            }, 0);
            next(); // 用户已登录，允许访问
          } else {
            next("/user/login"); // 未登录，跳转到登录页
          }
        }).catch(() => {
          console.info("验证登录失败");
          next("/user/login"); // 请求失败或验证失败，跳转到登录页
        });
    } else {
      console.info("token失效");
      next("/user/login"); // 未登录，跳转到登录页
    }
  } else {
    // console.info("不需要登录拦截");
    // 异步操作后再跳转
    setTimeout(() => {
      next();
    }, 0);
  }
});

export default router;
